import { GzPolicyUiSettingsGridItemFormWebComponent } from '../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/form';
import { html, TemplateResult } from 'lit';
import { translateFn } from '../../../../../../../../../../utils/translator.helper';
import { RequiredValidator } from '../../../../../../../../../../ui/gzForm/validators/required.validator';
import { CustomizableValidator } from '../../../../../../../../../../ui/gzForm/validators/customizable.validator';
import { validateScopeByType } from './utils/validators';
import { customElement, query } from 'lit/decorators.js';
import { GzFormFieldWebComponent } from '../../../../../../../../../../ui/gzForm/formField';
import { GzDropdownWebComponent } from '../../../../../../../../../../ui/gzDropdown';
import { GzInputWebComponent } from '../../../../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { FormGroup } from '../../../../../../../../../../ui/gzForm/formGroup/form-group';
import { WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_SCAN_TASKS_EXCLUSIONS_ITEM } from '../../../../../../../../../../webcomponents.constants';
import { ExchangeAntimalwareScanTaskTargetExclusionType } from '@nirvana/shared/dtos/types/policies/common';
import { getExchangeAntimalwareScanTaskExclusionTypeFormOptions } from '../../../../../../../utils/uiSettings/exchange/exchange-protection.values';

@customElement(WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_SCAN_TASKS_EXCLUSIONS_ITEM)
export class GzExchangeAntimalwareScanTaskExclusionItemFormWebComponent extends GzPolicyUiSettingsGridItemFormWebComponent {
  @query('#excludedItemType')
  excludedItemType: GzFormFieldWebComponent<GzDropdownWebComponent>;

  @query('#excludedItemScope')
  excludedItemScope: GzFormFieldWebComponent<GzInputWebComponent, string>;

  public setError(error: string) {
    this.excludedItemScope.setError(error);
  }

  renderFormFields(): TemplateResult {
    return html`
      <div class="policy-grid-item-form--field excluded-item-type">
        <gz-form-field id="excludedItemType">
          <gz-dropdown
            @selectionChanged="${this.handleTypeFieldChange}"
            gz-form-input
            label="${translateFn('Type')}"
            .value=${ExchangeAntimalwareScanTaskTargetExclusionType.EMAIL}
            .options=${getExchangeAntimalwareScanTaskExclusionTypeFormOptions()}
          ></gz-dropdown>
        </gz-form-field>
      </div>

      <div class="policy-grid-item-form--field excluded-item-path w-full">
        <gz-form-field id="excludedItemScope">
          <gz-input
            gz-form-input
            label="${translateFn('Scope')}"
            placeholder="${translateFn('Email address')}"
          ></gz-input>
        </gz-form-field>
      </div>
    `;
  }

  createFormGroup(): void {
    this.excludedItemType.Validators = [RequiredValidator('')];
    this.excludedItemScope.Validators = [
      RequiredValidator(translateFn('Required field')),
      CustomizableValidator(value =>
        validateScopeByType(this.excludedItemType.value as ExchangeAntimalwareScanTaskTargetExclusionType, value)
      ),
    ];

    this.formGroup = new FormGroup({
      type: this.excludedItemType,
      scope: this.excludedItemScope,
    });
  }

  private handleTypeFieldChange(event: CustomEvent) {
    this.excludedItemScope.validate();

    switch (event.detail.value) {
      case ExchangeAntimalwareScanTaskTargetExclusionType.EMAIL:
        this.excludedItemScope.Input.placeholder = translateFn('Email address');
        break;
      case ExchangeAntimalwareScanTaskTargetExclusionType.PUBLIC_FOLDER:
        this.excludedItemScope.Input.placeholder = translateFn('Folder path');
        break;
      case ExchangeAntimalwareScanTaskTargetExclusionType.DATABASE:
        this.excludedItemScope.Input.placeholder = translateFn('Database identity');
        break;
      default:
        this.excludedItemScope.Input.placeholder = translateFn('Type here');
    }
  }

  resetForm(resetType = true): void {
    if (resetType) {
      this.excludedItemType.value = ExchangeAntimalwareScanTaskTargetExclusionType.EMAIL;
      this.excludedItemType.resetField();
    }

    this.excludedItemScope.value = '';
    this.excludedItemScope.resetField();
  }

  reset() {
    this.resetForm();
  }

  resetOnAdd() {
    this.resetForm(false);
  }
}
